

import blogCategories from '@/apollo/queries/blog/blogCategories'
import blogAuthors from '@/apollo/queries/blog/blogAuthors'

export default {
  name: 'BlogAuthorFilterSection',
  props: {
  },
  data() {
    return {
      activeItem: "",
      isCategoryActive: true,
      isAuthorActive: false,
      blogCategories: [],
      blogAuthors: [],
      showDesktopMenu: false
    }
  },
  computed: {
    storeShowDesktopMenu() {
      return this.$store.getters['blog/showDesktopMenu'] 
    }
  },
  watch: {
    storeShowDesktopMenu(newValue, oldValue) {
      console.debug(`showDesktopMenu newValue, oldValue: `,newValue, oldValue)
      this.showDesktopMenu = newValue 
    }
  },
  methods: {
    handleAuthorClicked(slug) {
      this.$router.push({ 
        path: `/${this.$i18n.locale}/blog/author/${slug}`, 
      })
    },
    showMobileMenu() {
      this.$store.commit('blog/setMobileMenuState', true);
    },
    setDesktopMenu(boolean) {
      this.$store.commit('blog/setDesktopMenuState', boolean);
    }
  },
  apollo: {
      blogCategories: {
          prefetch: true,
          query: blogCategories,
          variables() {
              return { currentlocale: this.$normalizeLocale(this.$i18n.locale) };
          },
          update(data) {
              return this.$normalizeStrapi(data.blogCategories.data);
          },
          result({ data }) {
              // console.debug("***apollo blogCategories data ***");
              // console.debug(JSON.stringify(data));
          }
      },
      blogAuthors: {
          prefetch: true,
          query: blogAuthors,
          variables() {
              return { currentlocale: this.$normalizeLocale(this.$i18n.locale) };
          },
          update(data) {
              return this.$normalizeStrapi(data.blogAuthors.data);
          },
          result({ data }) {
              // console.debug("***apollo blogAuthors data ***");
              // console.debug(JSON.stringify(data));
          },
      },
    },
  }
